// extracted by mini-css-extract-plugin
export default {"wrap":"styles_wrap__c6Eyy","bigValue":"styles_bigValue__O0uOI","popup":"styles_popup__YTHqo"};